<template>
  <div>
    <swigi-header-child
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
    />
    <swigi-body-child
      :log="log"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
      :listSections="listSections"
      :currentTab="currentTab"
      :setCurrentTab="setCurrentTab"
      :currentCurrency="currentCurrency"
      :addToCart="addToCart"
      :selectes_ids="selectes_ids"
    />
    <swigi-footer-child
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
    />
  </div>
</template>

<script>
import swigiHeader1 from "../headers/swigi.vue";
import swigiBody1 from "../body/swigi.vue";
import swigiFooter1 from "../footer/swigi.vue";
export default {
  components: {
    "swigi-header-child": swigiHeader1,
    "swigi-body-child": swigiBody1,
    "swigi-footer-child": swigiFooter1,
  },
  props: [
    "addToCart",
    "selectes_ids",
    "changeName",
    "currentLang",
    "newItem",
    "restaurant",
    "log",
    "functionCollapsed",
    "newSection",
    "listSections",
    "currentTab",
    "setCurrentTab",
    "changeSectionTitle",
    "changeSectionSubTitle",
    "addItem",
    "newSubSection",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "changeItemObservation",
    "changeItemTitle",
    "changeItemPrice",
    "editCategorie",
    "deleteSection",
    "editSubCategorie",
    "deleteSubSection",
    "editItem",
    "currentCurrency",
    "deleteItem",
    "currentSmalerTab",
    "listSectionsSmaller",
  ],
  data() {
    return {};
  },
  methods: {},
  watch: {},
};
</script>

<style>
@import url("../styles/feather.css");
@import url("../styles/vendor/bootstrap/css/bootstrap.min.css");
@import url("../styles/style.css");
@import url("../styles/vendor/sidebar/demo.css");

.custom-img {
  height: 148px;
  object-fit: cover;
}
.custom-img-slider {
  height: 160px;
  width: 100%;
}
.tags {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  align-items: center;
}
.tags img {
  height: 26px;
  margin-right: 8px;
}
.tagSales {
  height: 20px !important;
}
</style>
